import React from "react"
import { Spin } from "antd"

type LoadingProps = {
  loading: boolean
  tip: string
}

export default function Loading({ loading = true, tip = "" }: LoadingProps) {
  return loading ? (
    <div
      className="loading"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <Spin tip={tip} size="large" />
    </div>
  ) : null
}
